import React from 'react';

function CompetitionRulesView({ combinedRulesCatalog, currentRulesSelection, rulesPickerContext, setEditingCompSettings, setViewTracked, toggleDraftCompetitionRule }) {
  return (
    <div className="page-container-md">
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
        <button className="w3-button w3-theme-l4 w3-round" onClick={() => {
          if (rulesPickerContext === 'edit') {
            setViewTracked('competition');
            setEditingCompSettings(true);
          } else {
            setViewTracked('newComp');
          }
        }}>
          <i className="fa fa-arrow-left"></i>
        </button>
        <h2 style={{ margin: 0 }}><i className="fa fa-book w3-text-theme w3-margin-right"></i>Competition Rules</h2>
      </div>
      <p className="w3-text-grey" style={{ marginTop: 0 }}>
        Tick the rules that apply to this competition. Selected rules will be shown on competition home and can be printed.
      </p>

      <div className="w3-card w3-round w3-white">
        <div className="w3-container w3-padding">
          {combinedRulesCatalog.length === 0 ? (
            <p className="w3-text-grey"><em>No rules available. Add rules in Admin → Rules Bank.</em></p>
          ) : (
            <div>
              {combinedRulesCatalog.map(rule => {
                const selected = currentRulesSelection.some(r => r.id === rule.id);
                return (
                  <label key={rule.id} className="w3-border-bottom" style={{ display: 'block', padding: '10px 4px', cursor: 'pointer' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                      <input type="checkbox" className="w3-check" checked={selected}
                        onChange={e => toggleDraftCompetitionRule(rule, e.target.checked)} style={{ marginTop: '2px' }} />
                      <div>
                        <div style={{ fontWeight: 700 }}>
                          {rule.title}
                          <span className="w3-tag w3-round w3-theme-l5" style={{ marginLeft: '8px', fontSize: 'var(--gs-text-xs)' }}>{rule.source === 'site' ? 'Site' : 'Club'}</span>
                        </div>
                        {rule.detail && <div className="w3-small w3-text-grey" style={{ marginTop: '2px' }}>{rule.detail}</div>}
                      </div>
                    </div>
                  </label>
                );
              })}
            </div>
          )}

          <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
            <button className="w3-button w3-theme w3-round" onClick={() => {
              if (rulesPickerContext === 'edit') {
                setViewTracked('competition');
                setEditingCompSettings(true);
              } else {
                setViewTracked('newComp');
              }
            }}>
              <i className="fa fa-check w3-margin-right"></i>Done
            </button>
            <span className="w3-text-grey w3-small" style={{ alignSelf: 'center' }}>
              {currentRulesSelection.length} selected
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompetitionRulesView;
